import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import CustomizationModel from '/chat/src/redux/model/customization/model';
import style from './style.scss';
class Textarea extends Component {
    constructor(props){
        super(props)
        this.state = {
            value: props.value || '',
            focus: false,
            onLabelHover: false,
        }
        this.onChange = this.onChange.bind(this)
        this.inputRef = null
        this.setFocus = this.setFocus.bind(this)
    }

    onChange(event){
        this.setState({value: event.target.value})
        if(this.props.onChange){
            this.props.onChange(event.target.value)
        }
    }
    setFocus(){
        this.setState({focus: true})
        if(this.inputRef){
            this.inputRef.focus()
        }
    }

    render(){
        let {width, label, autocomplete, require, missing} = this.props
        return(
            <span className={style.InputWrapper}
                onClick={this.setFocus}
            >
            {
                <span className={this.state.value || this.state.focus || this.state.hover ?style.TextareaLabelHover:style.TextareaLabel}>
                {label} {require && missing && this.props.language.get('Require')}</span>
            }
            <textarea className={style.Textarea}
                ref={inputRef => this.inputRef= inputRef}
                onfocus={() => {this.setState({focus: true})}}
                onBlur={() => this.setState({focus: false})}
                onInput={this.onChange}
                value={this.state.value}
                id={label}
                style = {require && missing &&  {
                    border: '2px solid #ff6d67'
                }}
            />
            <span className={style.TextareaRequired}
                onMouseEnter={()=>this.setState({onLabelHover: true})}
                onMouseLeave={()=>this.setState({onLabelHover: false})}
            > * </span>
            {this.state.onLabelHover && <span className={style.LabelRequiredMissing}
            > {label} </span>}
            {require && missing && <span className={style.InputRequiredMissing}> * </span>}
            </span>
        )
    }
}

function mapStateToProps(state){
    return {
        language: CustomizationModel.getLanguage(state)
    };
}

export default connect(mapStateToProps)(Textarea);



// WEBPACK FOOTER //
// ./components/Forms/Textarea.js